import { useGetFareFamilyInfoQuery } from '@/src/api/rtkQuery/fareFamilyApi'
import useGetItineraryId from '@/src/hooks/itinerary/useGetItineraryId'

const useFareFamilyInfoApi = ({ skip = false }: { skip?: boolean }) => {
    const itineraryId = useGetItineraryId()
    useGetFareFamilyInfoQuery(
        {
            itineraryId
        },
        {
            skip
        }
    )
}

export default useFareFamilyInfoApi
